export const RESYNC_ORDERS_REQUEST = "RESYNC_ORDERS_REQUEST";
export const RESYNC_ORDERS_SUCCESS = "RESYNC_ORDERS_SUCCESS ";
export const RESYNC_ORDERS_ERROR = "RESYNC_ORDERS_ERROR";
